import Tippy from "@tippyjs/react"

export const AdjustRealChainTooltip = () => {
    return(
        <Tippy
            content={
            <div className="text-sm text-left max-w-sm z-50">
                <p className="mb-2">If you don't already have data for Real Chain, you can choose Estimated Chain or Calculated Chain to populate the Real Chain columne.</p>

                <p className="mb-2">Calculated Chain is calculated by Martrak, based on AGM lat/lng. If subchains are present, they are taken into account.</p>

                <p className="mb-2">All the data for Estimated Chain OR Calculated Chain will be copied into the Real Chain column.</p>

                <p>Real Chain Delta is calculated once Real Chain is filled in.</p>
            </div>
            }
            interactive
            delay={[200, 0]}
            placement="bottom"
        >
            <i
                className="fa-solid fa-circle-question text-violet-800 cursor-help text-sm"
                aria-label="What does 'adjust real chain' mean?"
            />
        </Tippy>
    )
}